import { SsoWhitelistEmailList } from 'pages/configurations/sso_whitelist_emails';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'sso_whitelist_emails',
  label: 'Lista de Permissão (SSO)',
  list: SsoWhitelistEmailList,
  actions: ['list', 'create', 'delete'],
  parentName: 'configurations'
};

export default generateResources(resource);
